import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import axios from 'src/app/Service/axios';
import { AudioRecordingService } from 'src/app/Service/audio-recording.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';

declare let $: any;

@Component({
  selector: 'app-push-modal',
  templateUrl: './push-modal.component.html',
  styleUrls: ['./push-modal.component.css'],
})
export class PushModalComponent implements OnInit {
  @Input() canSendPayamak = false;

  isAudioRecording = false;
  audioRecordedTime: any;
  audioSrcUrl: any = '';

  pushForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private gurdService: GurdServiceService,
    private notify: NotificationService,
    private otherService: OtherService,
    private audioRecordingService: AudioRecordingService,
    private sanitizer: DomSanitizer,
    private ref: ChangeDetectorRef,
  ) {
    this.pushForm = this.fb.group({
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      lststrUnitIDs: new FormControl('', Validators.required),
      strTitle: new FormControl('', Validators.required),
      strMessage: '',
      strVoice: '',
      iPushType: '',
      tiType: '4',
      bSMS: false,
    });
  }

  ngOnInit(): void {
    this.subscribeToAudioRecorder();
  }

  get pushType(): any {
    return this.pushForm.get('iPushType')?.value;
  }

  open(unitIds: string[]): void {
    this.pushForm.patchValue({
      lststrUnitIDs: unitIds,
      strTitle: '',
      strMessage: '',
      strVoice: '',
      iPushType: 0,
      bSMS: false,
    });
    this.audioSrcUrl = '';
    this.isAudioRecording = false;
    $('#Push_Modal').modal('show');
  }

  setType(type: string): void {
    this.pushForm.get('iPushType')?.setValue(type);
  }

  back(): void {
    this.pushForm.get('iPushType')?.setValue('0');
  }

  async send(): Promise<void> {
    const pushType = this.pushType;
    if (this.pushForm.invalid)
      return this.notify.showError('عنوان را وارد کنید');
    if (pushType == 1 && !this.pushForm.get('strMessage')?.value.trim())
      return this.notify.showError('متن پیام را وارد کنید');
    if (pushType == 2 && !this.pushForm.get('strVoice')?.value)
      return this.notify.showError('صدا را ضبط کنید');

    if (pushType == 2) {
      this.pushForm.get('strMessage')?.setValue('');
      this.pushForm.get('tiType')?.setValue('4');
    }
    if (pushType == 1) {
      this.pushForm.get('strVoice')?.setValue('');
      this.pushForm.get('tiType')?.setValue('0');
    }

    this.otherService.Showspinner();
    const model = this.otherService.stringNumberToNumber(this.pushForm.value);
    const response = await axios.post(`SendPush2MobilesSelected`, model);
    this.otherService.nonespinner();

    const res = JSON.parse(response.data.toString());
    if (res.iResult == 0) return this.notify.showError(res.strError);

    this.notify.showSuccess('پیام با موفقیت ارسال شد');
    this.pushForm.patchValue({
      lststrUnitIDs: '',
      strTitle: '',
      strMessage: '',
      strVoice: '',
      bSMS: false,
    });
    $('#Push_Modal').modal('hide');
  }

  startAudioRecording(): void {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(() => {
        if (!this.isAudioRecording) {
          this.isAudioRecording = true;
          this.audioRecordingService.startRecording();
        }
      })
      .catch((err) => {
        if (err.message == 'Requested device not found') {
          this.notify.showError('سیستم شما دارای میکروفون نمی باشد');
        } else {
          alert('خطا در ضبظ صدا');
        }
      });
  }

  clearRecordedAudio(): void {
    this.pushForm.get('strVoice')?.setValue('');
    this.audioSrcUrl = '';
    this.notify.showSuccess('صدا با موفقیت حذف شد');
  }

  stopAudioRecording(): void {
    if (!this.isAudioRecording) return;
    this.audioRecordingService.stopRecording();
    this.isAudioRecording = false;
    this.pushForm.get('strMessage')?.setValue('');
    this.pushForm.get('tiType')?.setValue('4');
    this.playAudio();
  }

  isAudioRecorded(): boolean {
    return !!this.pushForm.get('strVoice')?.value;
  }

  private playAudio(): void {
    setTimeout(() => {
      this.audioSrcUrl = this.sanitizer.bypassSecurityTrustUrl(
        `data:audio/mp3;base64,` + this.pushForm.get('strVoice')?.value,
      );
    }, 200);
  }

  private blobToBase64(blob: any): Promise<unknown> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  private subscribeToAudioRecorder(): void {
    this.audioRecordingService.recordingFailed().subscribe(() => {
      this.isAudioRecording = false;
      this.ref.detectChanges();
    });

    this.audioRecordingService.getRecordedTime().subscribe((time) => {
      this.audioRecordedTime = time;
      if (time == '00:21') {
        this.stopAudioRecording();
        this.notify.showError('حده اکثر زمان ضبط صدا 20 ثانیه است');
      }
      this.ref.detectChanges();
    });

    this.audioRecordingService.getRecordedBlob().subscribe((data) => {
      this.blobToBase64(data.blob).then((result: any) => {
        this.pushForm
          .get('strVoice')
          ?.setValue(result.replace('data:audio/wav;base64,', ''));
      });
      this.audioSrcUrl = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(data.blob),
      );
      this.ref.detectChanges();
    });
  }
}
